(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header__top-bar-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {

    var $carousel = $('.top-bar-carousel');
    var flkty = $carousel.data('flickity');

    if ($carousel.length) {
      $carousel.flickity({
        lazyLoad: 0,
        cellAlign: "right",
        wrapAround: false,
        imagesLoaded: false,
        freeScroll: false, 
        fade:true, 
        draggable: false, 
        prevNextButtons: false, 
        pageDots:false, 
        autoPlay: 3500, 
        transition: 3800,
        pauseAutoPlayOnHover: false
      });

      $('.carousel-cell').addClass('pageloaded');

      let flkty = $carousel.data('flickity');

      function updateSlideBackgroundTopBar(){
          let $selectedCell = $(flkty.selectedElement);
          let $childWithBg = $selectedCell.find('[data-bg-slide]').first();
          let $bgValue = $childWithBg ? $childWithBg.attr('data-bg-slide') : null;

          if ($bgValue) {
            if ($bgValue.startsWith('#') || $bgValue.startsWith('rgb')) {
              $('.top-bar').css({
                background: $bgValue
              });
            }
          }
      }
    
      $carousel.on('change.flickity', function(event, index) {
        updateSlideBackgroundTopBar();
      });

      updateSlideBackgroundTopBar();

    }

  });

  } catch(e) { console.error(e); }
})();
})();
